import config from 'configDir/index';
import { get, del, post } from './http';

// 获取列表
const getVideoDeviceListService = get(`/devices`, config.videoUrl);

// 视频播放
const videoService = get(`/devices/streams`, config.videoUrl);
// 关闭视频播放
const closeVideoService = del(`/devices/streams`, config.videoUrl);
// 保活视频播放流
const activeVideoService = post(`/devices/streams`, config.videoUrl);

// 获取场所列表
const mainVideoService = get(`/28181/sipserver/queryVideoPlatformList`, config.commonServiceUrl);

// 临沧获取28181地址
const getVideoDeviceService = get(`/28181/sipserver/getVedioDevice`, config.commonServiceUrl);

const getVideoAddressService = get(`/28181/sipserver/getVideoAddress`, config.commonServiceUrl);

export {
  getVideoDeviceListService,
  videoService,
  closeVideoService,
  mainVideoService,
  activeVideoService,
  getVideoDeviceService,
  getVideoAddressService,
};
